module.exports = __webpack_public_path__ + "static/media/ParisStory2.bf4119f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/ParisStory2.png
// module id = 144
// module chunks = 0